import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { LegalTable } from '../components/LegalLayout';
import { COMPANY, LEGAL_PAGES } from '../lib/company';
import { useSEO } from '../hooks/useSEO';

const { emails } = COMPANY;

const sections = [
  {
    id: 'company',
    title: 'Company information',
    body: (
      <>
        <p>
          The website ip9.io and the IP9 Services are operated by <strong>{COMPANY.legalName}</strong>. {COMPANY.tradingName} is a trading name of {COMPANY.legalName}.
        </p>
        <LegalTable
          head={['', '']}
          rows={[
            ['Registered name', COMPANY.legalName],
            ['Trading name', COMPANY.tradingName],
            ['Legal form', 'Private company limited by shares'],
            ['Registered in', COMPANY.jurisdiction],
            ['Company number', COMPANY.companyNumber],
            ['Registered office', COMPANY.address],
            ['Email', <a href={`mailto:${emails.support}`}>{emails.support}</a>],
            ['Companies House record', <a href={`https://find-and-update.company-information.service.gov.uk/company/${COMPANY.companyNumber}`} target="_blank" rel="noopener noreferrer">View on Companies House</a>],
          ]}
        />
      </>
    ),
  },
  {
    id: 'contacts',
    title: 'Points of contact',
    body: (
      <LegalTable
        head={['Topic', 'Contact']}
        rows={[
          ['Customer support and complaints', <a href={`mailto:${emails.support}`}>{emails.support}</a>],
          ['Privacy and data protection requests', <a href={`mailto:${emails.privacy}`}>{emails.privacy}</a>],
          ['Abuse reports', <a href={`mailto:${emails.abuse}`}>{emails.abuse}</a>],
          ['Legal notices, and authorities (including under the EU Digital Services Act). Languages: English', <a href={`mailto:${emails.legal}`}>{emails.legal}</a>],
        ]}
      />
    ),
  },
  {
    id: 'documents',
    title: 'Legal documents',
    body: (
      <ul>
        {LEGAL_PAGES.filter((p) => p.href !== '/legal').map((p) => (
          <li key={p.href}>
            <Link to={p.href}>{p.label}</Link>
          </li>
        ))}
      </ul>
    ),
  },
  {
    id: 'content',
    title: 'Website content',
    body: (
      <p>
        We take care to keep this website accurate, but its content is for general information and may change without notice. Network size, locations and performance figures describe typical availability and are not a
        guarantee unless agreed in writing. Trademarks of third parties are the property of their owners. Their use on this site does not imply endorsement.
      </p>
    ),
  },
];

const LegalNoticePage = () => {
  useSEO('legalNotice');
  return <LegalLayout title="Legal Notice" sections={sections} />;
};

export default LegalNoticePage;
